import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'form'];

  toggleAll({ target }) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = target.checked;
    });
  }

  submitForm(event) {
    const selectedCheckboxes = this.checkboxTargets.filter((checkbox) => checkbox.checked);

    if (selectedCheckboxes.length === 0) {
      event.preventDefault();
      App.notifyError('手配を選択してください');
      return;
    }

    const form = this.formTarget;

    selectedCheckboxes.forEach((checkbox) => {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = 'tour_arrangement_ids[]';
      hiddenField.value = checkbox.dataset.tourArrangementId;
      form.appendChild(hiddenField);
    });
  }
}
